import { render, staticRenderFns } from "./applicant-followUp.vue?vue&type=template&id=be6a3458&scoped=true"
import script from "./applicant-followUp.vue?vue&type=script&lang=js"
export * from "./applicant-followUp.vue?vue&type=script&lang=js"
import style0 from "./applicant-followUp.vue?vue&type=style&index=0&id=be6a3458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a3458",
  null
  
)

export default component.exports